<template>
  <div>
    <b-card no-body>
      <b-card-header>
        <b>Group Sharing</b>
        <b-button
          v-show="hasGroups"
          v-if="isOrgAdmin && hasMoreGroupsToShareWith"
          disabled
          type="button"
          variant="outline-primary"
          size="sm"
          class="float-right"
        >
          <span class="button-text">Share with</span>
        </b-button>
      </b-card-header>

      <!-- List groups -->
      <div v-if="shareAdvocateRecords.length > 0">
        <b-list-group v-for="sp in shareAdvocateRecords" :key="sp.id" flush>
          <b-list-group-item>
            <a href="" @click.prevent="toggleUpdateShareAdvocateModal(sp.id)">
              {{ _.get(sp, 'sgroup.groupName', 'Unknown') }} <img :src="'/static/img/' + (sp.advocateShareStatus ? 'shareYes.png' : 'shareNo.png')" height="21" width="21">
            </a>
          </b-list-group-item>
        </b-list-group>
      </div>

      <div v-if="shareAdvocateRecords.length === 0">
        <b-list-group flush>
          <b-list-group-item>
            <p>{{ !hasGroups ? 'Your organization does not belong to any groups' : 'This record is not currently shared' }}</p>
          </b-list-group-item>
        </b-list-group>
      </div>
    </b-card>

    <!-- View/Update Existing -->
    <UpdateShareAdvocateModal
      :advocateId="advocateId"
      :advocateOrganizationOwner="advocateOrganizationOwner"
      :shareRecord="shareRecord"
      :groupId="selectedGroup"
    ></UpdateShareAdvocateModal>

  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import UpdateShareAdvocateModal from '@/components/Share/UpdateShareAdvocateModal'

export default {
  name: 'share-advocate-list',
  props: {
    advocateId: Number,
    advocateOrganizationOwner: Number,
    personId: Number
  },
  components: {
    UpdateShareAdvocateModal
  },
  data: function () {
    return {
      showUpdateAdvocateModal: false,
      selectedGroup: {},
      shareRecordId: 0
    }
  },
  computed: {
    ...mapGetters({
      shareAdvocateRecords: 'shareAdvocateRecords',
      // userShareAllowedGroups: 'userShareAllowedGroups',
      getGroupsByOrg: 'getGroupsByOrg',
      userTransferAllowed: 'userTransferAllowed',
      userCurrentContext: 'userCurrentContext' // Passing user context to determine if they have isOrgAdmin
    }),
    hasGroups: function () {
      let groups = this.getGroupsByOrg
      return groups.length > 0
    },
    hasMoreGroupsToShareWith: function () {
      let condition = false
      let countGroups = this.getGroupsByOrg.length || 0
      let countShareRecords = this.shareAdvocateRecords.length || 0
      if (countGroups > countShareRecords) {
        condition = true
      }
      return condition
    },
    isOrgAdmin: function () {
      return this.userTransferAllowed(this.advocateOrganizationOwner)
    },
    shareRecord: function () {
      return this.shareAdvocateRecords.find((r) => r.id === this.shareRecordId)
    }
  },
  watch: {
    advocateId: function (newValue) {
      if (newValue && _.isInteger(newValue)) {
        this.$store.dispatch('getShareAdvocateRecords', {
          sadvocate: newValue,
          populate: 'sgroup,sadvocate'
        })
      }
    }
  },
  methods: {
    toggleUpdateShareAdvocateModal: function (shareRecordId) {
      this.shareRecordId = shareRecordId
      this.$bvModal.show('update-share-advocate')
    },
    resetAll: function () {
      this.$store.commit('RESET_SHARE_RESPONSE', { name: 'shareAdvocateResponse' })
      this.$store.commit('RESET_SHARE_ADVOCATE_RECORDS')
    }
  },
  beforeDestroy () {
    this.resetAll()
  },
  created () {
    if (this.advocateId && _.isInteger(this.advocateId)) {
      this.$store.dispatch('getShareAdvocateRecords', {
        sadvocate: this.advocateId,
        populate: 'sgroup,sadvocate'
      })
      this.$store.dispatch('getGroupsByOrg', { id: this.advocateOrganizationOwner })
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Advocate/ShareAdvocateList.vue